import { getInstance } from "./axiosFactory";
import { raiseError } from "./globalActions";
import { saveState } from "../store/LocalStorage";
import { get } from "lodash";
import Swal from "sweetalert2";
const axiosInstance = getInstance();

// Tries the AppUser login endpoint. Returns true if it succeeded and
// the redirect has already been triggered; false if AppUser login also
// failed (caller should show its own "not authorized" message).
async function tryAppUserLogin(email, password, setLoading) {
	try {
		const res = await axiosInstance.post("/AppUser/Login", {
			Email: email,
			Password: password,
		});

		saveState({
			auth: { token: res.data.token, loggedIn: true },
		});

		localStorage.setItem("isAuthenticated", "true");
		localStorage.setItem("URole", "AppUser");
		localStorage.setItem("AppUserId", res.data.userId);

		window.location.href = "/";
		return true;
	} catch (err) {
		setLoading(false);
		return false;
	}
}

export function loginSuccess(loginResult) {
	return { type: "LOGIN_SUCCESSFUL", loginResult };
}

export function loginFailure(failure) {
	return { type: "LOGIN_FAILURE", failure };
}

export function logoutAction() {
	return { type: "LOGOUT" };
}

export const login = (username, Upassword, setLoading) => {
	console.log("the login", username, Upassword, axiosInstance);
	setLoading(true);

	axiosInstance
		.post("/login", {
			username: username,
			Upassword: Upassword
		})
		.then((res) => {
			if (res.data.require2FA === true) {
				// ✅ Show 2FA input prompt
				Swal.fire({
					html: `
    <h2 style="font-size: 20px !important; font-weight: 600; margin-bottom: 5px;">Two-Factor Authentication</h2>
    <p style="font-size: 14px; color: #666; margin-bottom: 15px;">
      Please enter the 6-digit code sent to your email.
    </p>
    <input type="text" id="twoFactorCode" class="swal2-input" placeholder="Enter 2FA Code">
  `,
					showConfirmButton: true,
					confirmButtonText: "Verify",
					confirmButtonColor: "rgb(255, 198, 62)",
					didRender: () => {
						const btn = document.querySelector(".swal2-confirm");
						if (btn) {
							btn.style.color = "black";
							btn.style.fontWeight = "600";
						}
					},
					focusConfirm: false,
					showLoaderOnConfirm: true,
					preConfirm: async () => {
						const code = document.getElementById("twoFactorCode").value;
						if (!code) {
							Swal.showValidationMessage("Please enter the code");
							return false;
						}

						try {
							const verifyRes = await axiosInstance.post("/verify-2fa", {
								userId: res.data.userId,
								code: code,
							});

							return verifyRes.data;
						} catch (err) {
							if (err.response && err.response.status === 400) {
								Swal.showValidationMessage(err.response.data.message || "Invalid code. Please try again");
							} else {
								Swal.showValidationMessage("Something went wrong. Try again.");
							}
							return false;
						}
					},
				}).then((result) => {
					if (result.isConfirmed && result.value) {
						const verifyData = result.value;

						saveState({
							auth: { ...verifyData, loggedIn: true },
						});

						localStorage.setItem("isAuthenticated", "true");
						localStorage.setItem("URole", verifyData.responce[0].role);
						localStorage.setItem("ManegerId", verifyData.responce[0].Id);

						window.location.href = "/";
					}
				});
			} else {
				// Not an Admin/Manager account -- try AppUser login before
				// giving up entirely.
				tryAppUserLogin(username, Upassword, setLoading).then((ok) => {
					if (!ok) {
						Swal.fire({
							title: "Error",
							text: "Not Authorized User",
							icon: "error",
							confirmButtonText: "Ok",
						});
						setLoading(false);
					}
				});
			}
		})
		.catch(error => {
			console.log("error occur", error);
			// /login itself failed (e.g. wrong Admin/Manager credentials,
			// or this email/username only exists as an AppUser). Try
			// AppUser login before giving up.
			tryAppUserLogin(username, Upassword, setLoading).then((ok) => {
				if (!ok) {
					Swal.fire({
						title: "Error",
						text: "Invalid username or password.",
						icon: "error",
						confirmButtonText: "Ok",
					});
					setLoading(false);
				}
			});
		});
	// };
};
export const forgetPasswordAction = (emailAddress) => {
	return axiosInstance.post("account/forgetPassword", { emailAddress });
}

export const resetPasswordAction = (newPassword, resetToken) => {
	return axiosInstance.post("account/resetPassword", { newPassword, resetToken });
}

export const resetPasswordURLVisitAction = (resetToken) => {
	return axiosInstance.post("account/resetpasswordurlvisitentry", { resetToken });
}

export const logout = () => {
	return dispatch => {
		localStorage.clear();
		saveState({});
		dispatch(logoutAction());
	};
};

// saveState({ auth: { ...get(res, "data"), loggedIn: true } });
// console.log("get value", res.data.responce[0].status);
// if (res.data.responce[0].status === "LoggedIn") {
// 	console.log("success")
// 	localStorage.setItem("isAuthenticated", "true");
// 	localStorage.setItem("URole", res.data.responce[0].role);
// 	localStorage.setItem('ManegerId', res.data.responce[0].Id);
// 	window.location.href = "/";

// }
